import React, { useState, useEffect, useRef } from "react";
import styles from "./testcallplayground.module.css";
import ReCAPTCHA from "react-google-recaptcha";
import audio from "../../../asset/audio.mp3";
import health from "../../../asset/healthavatar.png";
import customercare from "../../../asset/ccareavatar.png";
import lead from "../../../asset/leadavatar.png";
import voiceIcon from "../../../asset/voiceicon.png";
import leadmp3F from "../../../asset/lead.mp3";
import supportmp3F from "../../../asset/support.mp3";
import healthcaremp3F from "../../../asset/healthcare.mp3";
import leadmp3M from "../../../asset/LeadMale.mp3";
import supportmp3M from "../../../asset/CSmale.mp3";
import healthcaremp3M from "../../../asset/HealthMale.mp3";
import micOn from "../../../asset/micon.png";
import micOff from "../../../asset/micoff.png";
import speakerOn from "../../../asset/speakeron.png";
import speakerOff from "../../../asset/speakeroff.png";
import chevronDown from "../../../asset/chevrondown.png";
import endCallIcon from "../../../asset/endcall.png";
import bankM from "../../../asset/bankmale.mp3";
import bankF from "../../../asset/bankfemale.mp3";



const AGENTS = {
  lead: {
    name: "Lead Qualification",
    state: "Lead Qualification",
    desc: "#Real-Time Booking\n#Lead Qualification",
    status: "Available",
    avatarImg: lead,
    colorClass: "pink",
  },
  support: {
    name: "Customer Care",
    state: "Customer Care",
    desc: "#Real-Time Booking\n#Receptionist",
    status: "Available",
    avatarImg: customercare,
    colorClass: "green",
  },
  healthcare: {
    name: "Healthcare Receptionist",
    state: "Healthcare Receptionist",
    desc: "#Receptionist\n#Real-Time Booking",
    status: "Available",
    avatarImg: health,
    colorClass: "blue",
  },
  bankrecovery: {
    name: "Bank Recovery Agent",
    state: "Bank Recovery Agent",
    desc: "#Recovery\n#Debt Collection",
    status: "Available",
    avatarImg: health,
    colorClass: "green",
  },
};

const AGENT_AUDIO_MAP = {
  lead: {
    female: leadmp3F,
    male: leadmp3M,
  },
  support: {
    female: supportmp3F,
    male: supportmp3M,
  },
  healthcare: {
    female: healthcaremp3F,
    male: healthcaremp3M,
  },
  healthcare: {
    female: healthcaremp3F,
    male: healthcaremp3M,
  },
  bankrecovery: {
    female: bankF,
    male: bankM,
  },
};

const TestCallPlayground = () => {
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  // const [termsAccepted, setTermsAccepted] = useState(false);
  // const [captchaVerified, setCaptchaVerified] = useState(false);
  // const phoneValid = /^\d{10}$/.test(phone);
  // const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const [callEnded, setCallEnded] = useState(false);

  const [showVoiceSelector, setShowVoiceSelector] = useState(false);
  const [selectedVoice, setSelectedVoice] = useState(null); // "male" | "female"

  const [activeCallAgent, setActiveCallAgent] = useState(null);
  // null | "lead" | "support" | "healthcare"

  const resetCall = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      audioRef.current.muted = false;
    }

    setCallStatus("idle");
    setActiveCallAgent(null);
    setIsSpeakerOn(true);
    setIsMuted(false);
    setCallEnded(true);

    setShowVoiceSelector(false);
    setSelectedVoice(null);
  };

  // const formValid = phoneValid && emailValid && termsAccepted && captchaVerified;

  const [view, setView] = useState("agent"); // default to agent
  const [selectedAgent, setSelectedAgent] = useState("lead");
  const audioRef = useRef(null);
  const [callStatus, setCallStatus] = useState("idle");
  const openVoiceSelector = () => {
    setShowVoiceSelector(true);
  };
  const startCallWithVoice = (voice) => {
    if (!audioRef.current) return;

    setSelectedVoice(voice);
    setShowVoiceSelector(false);

    audioRef.current.muted = false;
    setIsSpeakerOn(true);
    setIsMuted(false);

    audioRef.current.src = AGENT_AUDIO_MAP[selectedAgent][voice];
    audioRef.current.currentTime = 0;
    audioRef.current.play();

    setCallTime(0);
    setCallStatus("calling");
    setActiveCallAgent(selectedAgent);
  };

  const endCall = () => {
    resetCall();
  };

  const [callTime, setCallTime] = useState(0);
  const timerRef = useRef(null);
  useEffect(() => {
    if (callStatus !== "calling") return;

    timerRef.current = setInterval(() => {
      setCallTime((t) => t + 1);
    }, 1000);

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [callStatus]);

  const formatTime = (sec) => {
    const m = String(Math.floor(sec / 60)).padStart(2, "0");
    const s = String(sec % 60).padStart(2, "0");
    return `${m}:${s}`;
  };

  const [isMuted, setIsMuted] = useState(false);
  const [isSpeakerOn, setIsSpeakerOn] = useState(true);

  const toggleMic = () => {
    setIsMuted((m) => !m);
  };

  const toggleSpeaker = () => {
    if (!audioRef.current) return;

    setIsSpeakerOn((prev) => {
      const next = !prev;
      audioRef.current.muted = !next; // speaker OFF → audio muted
      return next;
    });
  };

  return (
    <>
      {/* ===== AGENT PLAYGROUND VIEW ===== */}
      {view === "agent" && (
        <div className={styles.content}>
          {/* Left Panel */}
          <div className={styles.leftPanel}>
            <h3 className={styles.agentName}>{AGENTS[selectedAgent].state}</h3>
            <p className={styles.leftSubtitle}>Buyer Live</p>

            {Object.entries(AGENTS).map(([key, agent]) => (
              <div
                key={key}
                className={`${styles.useCaseCard} ${selectedAgent === key ? styles.activeCard : ""}`}
                onClick={() => {
                  if (callStatus === "calling" || callEnded) return; // 🚫 block switching
                  setSelectedAgent(key);
                }}
              >
                <div
                  className={`${styles.icon} ${styles[AGENTS[key].colorClass]}`}
                >
                  <img
                    src={voiceIcon}
                    alt="Voice"
                    className={styles.voiceIconOverlay}
                  />
                </div>

                <div>
                  <p className={styles.cardTitle}>{agent.name}</p>
                  <p className={styles.cardDesc}>{agent.desc}</p>
                </div>
              </div>
            ))}

            <p className={styles.orText}>or call from phone</p>

            <input
              className={styles.input}
              placeholder="Enter phone number"
              value={phone}
              onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
              maxLength={10}
            />

            <button
              className={styles.phoneButton}
              // onClick={startCall}
              disabled={callStatus === "calling" || phone.length !== 10}
            >
              📞 Call Now
            </button>
          </div>

          {/* Main Panel */}
          <div className={styles.playgroundScale}>
            <div className={styles.agentPanelWrapper}>
              {/* ================= IDLE VIEW (UNCHANGED) ================= */}
              {callStatus !== "calling" && !callEnded && (
                <>
                  <img
                    src={AGENTS[selectedAgent].avatarImg}
                    alt="Agent"
                    className={styles.avatarImg}
                  />

                  <h3 className={styles.agentName}>
                    {AGENTS[selectedAgent].name}
                  </h3>

                  <p className={styles.status}>
                    <span className={styles.statusDot} />
                    {AGENTS[selectedAgent].status}
                  </p>

                  <div className={styles.divider} />

                  {/* START CALL / VOICE SELECTOR */}
                  {!showVoiceSelector ? (
                    <button
                      className={`${styles.startCallBtn} ${styles[AGENTS[selectedAgent].colorClass]}`}
                      onClick={openVoiceSelector}
                    >
                      Start Call
                    </button>
                  ) : (
                    <div className={styles.voiceSelector}>
                      <button
                        className={styles.voiceBtn}
                        onClick={() => startCallWithVoice("female")}
                      >
                        🎤 Female Voice
                      </button>

                      <button
                        className={styles.voiceBtn}
                        onClick={() => startCallWithVoice("male")}
                      >
                        🎤 Male Voice
                      </button>
                    </div>
                  )}
                </>
              )}

              {/* ================= CALLING VIEW ================= */}
              {callStatus === "calling" &&
                activeCallAgent === selectedAgent && (
                  <>
                    <img
                      src={AGENTS[selectedAgent].avatarImg}
                      alt="Agent"
                      className={styles.avatarImg} // Reuse same large 225×225 avatar
                    />

                    <h3 className={styles.agentName}>
                      {AGENTS[selectedAgent].state}
                    </h3>

                    {/* Timer takes the place of status – same positioning/font size */}
                    <p className={styles.status}>
                      <span
                        className={styles.statusDot}
                        style={{ background: "#ef4444" }}
                      />{" "}
                      {/* red dot during call */}
                      {formatTime(callTime)}
                    </p>

                    <div className={styles.divider} />

                    {/* Call control buttons – centered like the Start Call button */}
                    <div className={styles.callActions}>
                      {/* MUTE CONTROL */}
                      <button
                        className={`${styles.callPill} ${isMuted ? styles.callPillActive : ""}`}
                        onClick={toggleMic}
                        title="Mic"
                      >
                        <img
                          src={isMuted ? micOff : micOn}
                          alt="Mic"
                          className={styles.callIcon}
                        />
                        <span className={styles.callText}>----</span>
                        <img
                          src={chevronDown}
                          alt=""
                          className={styles.chevron}
                        />
                      </button>

                      {/* SPEAKER CONTROL */}
                      <button
                        className={`${styles.callPill} ${!isSpeakerOn ? styles.callPillActive : ""}`}
                        onClick={toggleSpeaker}
                        title="Speaker"
                      >
                        <img
                          src={isSpeakerOn ? speakerOn : speakerOff}
                          alt="Speaker"
                          className={styles.callIcon}
                        />
                        <span className={styles.callText}></span>
                        <img
                          src={chevronDown}
                          alt=""
                          className={styles.chevron}
                        />
                      </button>

                      {/* END CALL */}
                      <button
                        className={styles.endCallBtn}
                        onClick={endCall}
                        title="End Call"
                      >
                        <img
                          className={styles.endCallBtnImg}
                          src={endCallIcon}
                          alt="End Call"
                        />
                      </button>
                    </div>
                  </>
                )}
              {/* ================= POST CALL VIEW ================= */}
              {callEnded && (
                <>
                  <img
                    src={AGENTS[selectedAgent].avatarImg}
                    alt="Agent"
                    className={styles.avatarImg}
                  />

                  <h3 className={styles.agentName}>
                    {AGENTS[selectedAgent].name}
                  </h3>

                  <div className={styles.divider} />

                  <button
                    className={`${styles.startCallBtn} ${styles[AGENTS[selectedAgent].colorClass]}`}
                    onClick={() => {
                      setCallEnded(false);
                      setCallStatus("idle");
                    }}
                  >
                    End Call
                  </button>
                </>
              )}

              <audio ref={audioRef} preload="auto" onEnded={resetCall} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TestCallPlayground;
